import * as React from 'react';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import HomeIcon from '@mui/icons-material/Home';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import AdminIcon from '@mui/icons-material/AdminPanelSettings';
import SupervisorIcon from '@mui/icons-material/Engineering';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PeopleIcon from '@mui/icons-material/People';
import ReportsIcon from '@mui/icons-material/Assessment';
import ServicesIcon from '@mui/icons-material/Build';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Entrances from '@mui/icons-material/DoorFrontOutlined';
import ElevatorIcon from '@mui/icons-material/Elevator';
import {getRoutePath} from '../utils/utilities';
import Header from './Header';
import {useSelector} from 'react-redux';

const drawerWidth = 240;

const Navigation = () => {
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const {user} = useSelector(s => s.user);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const path = getRoutePath(location, params);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = () => {
    return (
      <Box display="flex" flexDirection="column">
        <Toolbar>
          <Typography fontWeight="bold">UPLIFT</Typography>
        </Toolbar>
        {!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' && (
        <ListItem button selected={path === '/'} onClick={() => navigate('/')}>
          <ListItemIcon sx={path === '/' && {color: '#fff'}}>
            <HomeIcon />
          </ListItemIcon>
          <ListItemText>Dashboard</ListItemText>
        </ListItem>
        )}
        
        {!!user?.role && user?.role === 'SUPERADMIN' && (
          <ListItem
            button
            selected={path.includes('/admins')}
            onClick={() => navigate('/admins')}>
            <ListItemIcon sx={path.includes('/admins') && {color: '#fff'}}>
              <AdminIcon />
            </ListItemIcon>
            <ListItemText>Admins</ListItemText>
          </ListItem>
        )}

        {!!user?.role && user?.role === 'SUPERADMIN' && (
          <ListItem
            button
            selected={path.includes('/supervisors')}
            onClick={() => navigate('/supervisors')}>
            <ListItemIcon sx={path.includes('/supervisors') && {color: '#fff'}}>
              <SupervisorIcon />
            </ListItemIcon>
            <ListItemText>Supervisors</ListItemText>
          </ListItem>
        )}
        
        {!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' && (
        <ListItem
          button
          selected={path.includes('/projects')}
          onClick={() => navigate('/projects')}>
          <ListItemIcon sx={path.includes('/projects') && {color: '#fff'}}>
            <ApartmentIcon />
          </ListItemIcon>
          <ListItemText>Projects</ListItemText>
        </ListItem>
        )}

        {!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' && (
        <ListItem
          button
          // selected={path.includes('/entrances') || path.includes('/elevators')}
          selected={path.includes('/entrances') }
          onClick={() => navigate('/entrances')}>
          <ListItemIcon
            sx={
              // (path.includes('/entrances') || path.includes('/elevators')) && {
              (path.includes('/entrances')) && {
                color: '#fff',
              }
            }>
            <Entrances />
          </ListItemIcon>
          <ListItemText>Entrances</ListItemText>
        </ListItem>
        )}  
        
        <ListItem
          button
          selected={path.includes('/elevators')}
          onClick={() => navigate('/elevators')}>
          <ListItemIcon
            sx={
              (path.includes('/elevators')) && {
                color: '#fff',
              }
            }>
            <ElevatorIcon />
          </ListItemIcon>
          <ListItemText>Elevators</ListItemText>
        </ListItem>

        {!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' && (
        <ListItem
          button
          selected={path.includes('/customers') || path.includes('/card')}
          onClick={() => navigate('/customers')}>
          <ListItemIcon
            sx={
              (path.includes('/customers') || path.includes('/card')) && {
                color: '#fff',
              }
            }>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText>Customers</ListItemText>
        </ListItem>
        )}

        {!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' && (
        <ListItem
          button
          selected={path.includes('/reports')}
          onClick={() => navigate('/reports')}>
          <ListItemIcon sx={path.includes('/reports') && {color: '#fff'}}>
            <ReportsIcon />
          </ListItemIcon>
          <ListItemText>Reports</ListItemText>
        </ListItem>
        )}

        {!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' && (
        <ListItem
          button
          selected={path.includes('/services')}
          onClick={() => navigate('/services')}>
          <ListItemIcon sx={path.includes('/services') && {color: '#fff'}}>
            <ServicesIcon />
          </ListItemIcon>
          <ListItemText>Services</ListItemText>
        </ListItem>
        )}
      </Box>
    );
  };

  return (
    <>
      <CssBaseline />
      <Header handleDrawerToggle={handleDrawerToggle} />
      <Box
        component="nav"
        sx={{width: {sm: drawerWidth}, flexShrink: {sm: 0}}}
        aria-label="mailbox folders">
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: {xs: 'block', sm: 'none'},
            '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
          }}>
          {drawer()}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: {xs: 'none', sm: 'block'},
            '& .MuiDrawer-paper': {boxSizing: 'border-box', width: drawerWidth},
          }}
          open>
          {drawer()}
          <Box
            mt="auto"
            p="0 1rem 3rem"
            display="flex"
            gap="8px"
            alignItems="center">
            <Typography variant="body2">Copyright &copy; 2022</Typography>
            <Link href="https://www.coredevs.net" target="_blank">
              Coredevs
            </Link>
          </Box>
        </Drawer>
      </Box>
    </>
  );
};

export default Navigation;
